module.exports = __webpack_public_path__ + "work_team.2d7329479ba051d10eb1487d87f27105.hashedasset.svg";